module.exports = __webpack_public_path__ + "img/mega.dbfc76a0.png";